<template>
	<div class="ecology">
		<div class="m-top-box">
			<Nav/>
			<div class="m-layout-center">			
				<h2>数字生态</h2>
			</div>
		</div>
		<div class="m-layout-center">
			<div class="pt40">		
				<p class="s-gray-color1 f16 lh30 mb30 ti2">
					贵州是实施国家大数据战略的先行者，在政务服务、社会治理、公共事业等方面的大数据运用已形成若干成功案例。云码通率先统筹数字经济基础设施建设，利用大数据、人工智能、区块链和支付技术，连接融合各类经济活动主体，聚合交易要素，降低交易成本，提高经济效率，催生发展动能，形成数字经济发展的新引擎。在提升传统产业数字化、网络化、智能化水平的同时，支持新经济、新业态和中小微企业创新创业。
				</p>
				<div class="tac mb40 m-main-tit">
					<h3 class="s-main-color1">三大目标</h3>
					<div class="u-line"></div>
				</div>
				<ul class="m-dest-list mb40">
					<li class="fl mr24 tac">
						<img src="../assets/images/szst_sd_01@2x.png" alt="" width="130" height="120">
						<p class="u-txt-tit">服务数字政务</p>
						<p class="u-txt-info s-gray-color1 f14 lh22 tal">组织一流专业研究机构，结合人工智能技术，为政府工作人员和经济活动参与者推送高质量的研究报告和定制化的智能资讯；向有关部门推送“云码通”系统采集的经济行为数据，促进静态数据与行为数据的整合应用；为政府及有关部门提供数据挖掘、建模、比对、分析等服务，协助拓展政策执行、社会治理、招商引资和公用事业等应用场景，协助开展精准便捷高效的民生服务</p>
					</li>
					<li class="fl mr24 tac">
						<img src="../assets/images/szst_sd_02@2x.png" alt="" width="176" height="119">
						<p class="u-txt-tit">赋能经济发展</p>
						<p class="u-txt-info s-gray-color1 f14 lh22 tal">“云码通”适应新经济要求，以数据为核心要素、以支付为工具，构建适应社会化、网络化、平台化、数字化经济活动的统一账户系统，形成有机交互的供应链、价值链、生态圈，促进交易要素聚集，增强经济活力。通过新技术提升效率、降低成本、活跃交易，为新经济、新业态发展赋能，推动数字经济与实体经济的高度融合</p>
					</li>
					<li class="fl tac">
						<img src="../assets/images/szst_sd_03@2x.png" alt="" width="120" height="120">
						<p class="u-txt-tit">创新金融科技</p>
						<p class="u-txt-info s-gray-color1 f14 lh22 tal">运用大数据、区块链、物联网、人工智能等技术，为平台内企业提供供应链管理、客户管理、市场拓展、成本控制等金融科技解决方案，创新准确及时、动态交易、数字驱动的服务形式，推动企业的信息化应用水平不断升级，增强企业内生发展的科技动能，促进金融与实体的深度融合，实现产业科技与金融科技的耦合发展</p>
					</li>
				</ul>
				<div class="tac mb40 m-main-tit">
					<h3 class="s-main-color1">系统形态</h3>
					<div class="u-line"></div>
				</div>
				<p class="s-gray-color1 f16 lh30 mb30 ti2">
					“云码通”是以支付服务为核心的基础账户体系，为企业、个人开立实名制账户，通过自建APP和连接产业、企业、商圈等方法收集经济行为数据，将经济行为数据和静态数据有机结合，形成全局“链状、面状”数据模型，构建聚合新经济要素和新型组织的供应链、价值链生态圈，开展数字场景经济服务，升级数字政府运用
				</p>
				<div class="tac mb40">
					<img src="https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/szst_xtxt@2x.png" alt="" width="1064" height="680">
				</div>
				<div class="m-character-list mb40">
					<dl class="fl">
						<dt class="tac dt1">
							<img src="../assets/images/szst_xtxt_01@2x.png" alt="" width="93" height="86">
						</dt>
						<dd class="f14 lh26 s-gray-color1">
							以支付工具为手段，适时采集经济行为数据，建立经济活动信息流和资金流匹配的数字经济基础设施
						</dd>
					</dl>
					<dl class="fl">
						<dt class="tac dt2">
							<img src="../assets/images/szst_xtxt_02@2x.png" alt="" width="98" height="86">
						</dt>
						<dd class="f14 lh26 s-gray-color1">
							渗透交易节点，拓展交易场景，构建可测、可控、互信、活跃的数字经济生态圈
						</dd>
					</dl>
					<dl class="fl">
						<dt class="tac dt3">
							<img src="../assets/images/szst_xtxt_03@2x.png" alt="" width="81" height="75">
						</dt>
						<dd class="f14 lh26 s-gray-color1">
							利用人工智能和区块链技术，按照不同场景业务逻辑，设计固化业务流程，实现资金端、资产端的对应和穿透
						</dd>
					</dl>
					<dl class="fl">
						<dt class="tac dt4">
							<img src="../assets/images/szst_xtxt_04@2x.png" alt="" width="98" height="81">
						</dt>
						<dd class="f14 lh26 s-gray-color1">
							实现资金与数据聚集本地，运营与监管落地本土，“云码通”交易客户端延伸覆盖全国
						</dd>
					</dl>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped lang="scss">
	.m-top-box{ 
		width: 100%;
		padding-top: 10px;
		height: 390px;
		background: url(https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/szst_banner.png) no-repeat center top;
		background-size:cover; 
		h2 {
			color: #fff;
			font-size: 68px;
			font-weight: 500;
			text-align: center;
			height: 100px;
			line-height: 100px;
			margin-top: 166px;
			margin-bottom: 60px;
		}
	}
	.mr24{
		margin-right: 25px;
	}
	.m-dest-list{
		height: 410px;
		li{
			width:288px;
			height: 360px;
			padding: 24px 30px 26px;
			background: #FFFFFF;
			box-shadow: 2px 2px 20px 1px rgba(53,68,120,0.2);
			border-radius: 10px;
		}
		.u-txt-tit{
			font-size: 18px;
			line-height: 26px;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.u-txt-info{
			text-align: justify;
			text-justify: inter-ideograph;/*IE*/
		}
	}
	.m-character-list{
		width: 1200px;
		overflow: hidden;
		dl{
			width: 200px;
			margin-right: 100px;
			dt{
				line-height: 0;
			}
			.dt1{
				margin-bottom: 8px;
			}
			.dt2{
				margin-bottom: 8px;
			}
			.dt3{
				margin-bottom: 19px;
			}
			.dt4{
				margin-bottom: 12px;
			}
			dd{
				text-align: justify;
				text-justify: inter-ideograph;/*IE*/
			}
		}
	}
 </style>
<script>
import Nav from '@/components/Nav.vue'
export default {
  name:'ecology',
  components: {
    Nav
  }
}
</script>